var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',_vm._g({attrs:{"to":_vm.to,"event":''},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleClickInternal(_vm.to)}}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }